import { useState } from 'react'
import { Container, Tabs, Tab, Breadcrumb } from 'react-bootstrap'
import BudgetsList from '../../components/Budgets/BudgetsList'
import BudgetDashboard from '../../components/Budgets/BudgetDashboard'
import EstadoResultadosReport from '../../components/Reports/EstadoResultadosReport'
import BalanceGeneralReport from '../../components/Reports/BalanceGeneralReport'
import BalanzaComprobacionReport from '../../components/Reports/BalanzaComprobacionReport'
import AuxiliarCuentaReport from '../../components/Reports/AuxiliarCuentaReport'
import TransactionsList from '../../components/Accounting/TransactionsList'
import FinancialTransactionsList from '../../components/Financial/FinancialTransactionsList'
import ReportsDashboard from '../../components/Reports/ReportsDashboard'
import './Reports.css'

const Reports = () => {
  const [activeTab, setActiveTab] = useState('dashboard')
  const [auxiliarParams, setAuxiliarParams] = useState({
    clientId: '',
    accountId: '',
    startDate: '',
    endDate: ''
  })
  const [transactionsParams, setTransactionsParams] = useState({
    clientId: '',
    accountType: '',
    startDate: '',
    endDate: ''
  })
  const [financialTransactionsParams, setFinancialTransactionsParams] = useState({
    bankAccountId: '',
    transactionType: '',
    startDate: '',
    endDate: ''
  })
  const [breadcrumbs, setBreadcrumbs] = useState([])

  const handleDrillDown = (params, targetTab = 'auxiliar-cuenta') => {
    if (targetTab === 'auxiliar-cuenta') {
      setAuxiliarParams(params)
      setBreadcrumbs([
        { label: 'Reportes', tab: 'reports' },
        { label: params.fromReport || 'Reporte', tab: params.fromReportTab || 'reports' },
        { label: 'Auxiliar de Cuenta', tab: 'auxiliar-cuenta' }
      ])
    } else if (targetTab === 'transactions') {
      setTransactionsParams(params)
      setBreadcrumbs([
        { label: 'Reportes', tab: 'reports' },
        { label: params.fromReport || 'Reporte', tab: params.fromReportTab || 'reports' },
        { label: 'Transacciones Contables', tab: 'transactions' }
      ])
    } else if (targetTab === 'financial-transactions') {
      setFinancialTransactionsParams(params)
      setBreadcrumbs([
        { label: 'Reportes', tab: 'reports' },
        { label: params.fromReport || 'Reporte', tab: params.fromReportTab || 'reports' },
        { label: 'Transacciones Financieras', tab: 'financial-transactions' }
      ])
    }
    setActiveTab(targetTab)
  }

  const handleBreadcrumbClick = (tab) => {
    setActiveTab(tab)
    if (tab !== 'auxiliar-cuenta' && tab !== 'transactions' && tab !== 'financial-transactions') {
      setBreadcrumbs([])
    }
  }

  const handleSelectReport = (reportId) => {
    setActiveTab(reportId)
    setBreadcrumbs([])
  }

  return (
    <Container fluid className="reports-page">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Presupuestos y Reportes</h1>
      </div>

      {/* Breadcrumbs */}
      {breadcrumbs.length > 0 && (
        <Breadcrumb className="mb-3">
          {breadcrumbs.map((crumb, index) => (
            <Breadcrumb.Item
              key={index}
              active={index === breadcrumbs.length - 1}
              onClick={() => index < breadcrumbs.length - 1 && handleBreadcrumbClick(crumb.tab)}
              style={index < breadcrumbs.length - 1 ? { cursor: 'pointer' } : {}}
            >
              {crumb.label}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      )}

      <Tabs activeKey={activeTab} onSelect={(k) => {
        setActiveTab(k)
        if (k !== 'auxiliar-cuenta' && k !== 'transactions' && k !== 'financial-transactions') {
          setBreadcrumbs([])
        }
      }} className="mb-3">
        <Tab eventKey="dashboard" title="Dashboard">
          <BudgetDashboard />
        </Tab>
        <Tab eventKey="budgets" title="Presupuestos">
          <BudgetsList />
        </Tab>
        <Tab eventKey="reports" title="Reportes">
          <ReportsDashboard onSelectReport={handleSelectReport} />
        </Tab>
        <Tab eventKey="estado-resultados" title="Estado de Resultados">
          <EstadoResultadosReport onDrillDown={handleDrillDown} />
        </Tab>
        <Tab eventKey="balance-general" title="Balance General">
          <BalanceGeneralReport onDrillDown={handleDrillDown} />
        </Tab>
        <Tab eventKey="balanza-comprobacion" title="Balanza de Comprobación">
          <BalanzaComprobacionReport onDrillDown={handleDrillDown} />
        </Tab>
        <Tab eventKey="auxiliar-cuenta" title="Auxiliar de Cuenta">
          <AuxiliarCuentaReport 
            initialClientId={auxiliarParams.clientId}
            initialAccountId={auxiliarParams.accountId}
            initialStartDate={auxiliarParams.startDate}
            initialEndDate={auxiliarParams.endDate}
          />
        </Tab>
        <Tab eventKey="transactions" title="Transacciones Contables">
          <TransactionsList
            initialFilters={{
              client_id: transactionsParams.clientId,
              account_type: transactionsParams.accountType,
              start_date: transactionsParams.startDate,
              end_date: transactionsParams.endDate
            }}
          />
        </Tab>
        <Tab eventKey="financial-transactions" title="Transacciones Financieras">
          <FinancialTransactionsList
            initialFilters={{
              bank_account_id: financialTransactionsParams.bankAccountId,
              transaction_type: financialTransactionsParams.transactionType,
              start_date: financialTransactionsParams.startDate,
              end_date: financialTransactionsParams.endDate
            }}
          />
        </Tab>
      </Tabs>
    </Container>
  )
}

export default Reports
